import React from 'react'
import { IBranchModel } from './BranchModel'
import DataTable, { TableAction, TableColumn } from '../../../../shared/components/DataTable'

type Props = {
  data: IBranchModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void // Düzeltme: parametre tipi eklendi
  onEdit?: (branch: IBranchModel) => void // Düzeltme: Edit fonksiyonu eklendi
  onDelete?: (branch: IBranchModel) => void // Düzeltme: Delete fonksiyonu eklendi
  sortBy?: string // Düzeltme: Sort state'leri eklendi
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}

export const BranchTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false
}) => {
  const branchColumns: TableColumn<IBranchModel>[] = [
    { key: 'branchName', label: 'Şube Adı', className: 'fw-semibold' ,sortable: true},
    { key: 'city', label: 'Şehir' },
    { key: 'webOrder', label: 'Sayaç', sortable: true },
    { key: 'webParkingId', label: 'Web Şube Kodu' },
    { key: 'onlineReservationId', label: 'Web ID' },
  ]

  // Düzeltme: TableAction'da IBranchModel tipini kullan
  const branchActions: TableAction<IBranchModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (branch) => onEdit?.(branch), // Düzeltme: Parent'tan gelen fonksiyon
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (branch) => onDelete?.(branch), // Düzeltme: Parent'tan gelen fonksiyon
    },
  ]

  return (    <DataTable
      data={data}
      columns={branchColumns}
      actions={branchActions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Henüz şube bulunamadı'
    />
  )
}